import React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';

export enum PriceView {
  Gross = 'gross',
  Net = 'net',
}

const DEFAULT_COMMISSION = 5;

const useGetGrossPrice = () => {
  const agentInfo = useSelector((state: RootState) => state.config.agentInfo);
  const price_view = agentInfo?.agent?.price_view;
  // Tenant operators are served public gross prices straight from sky360-ms
  // and carry price_view 'gross' to say so. Uplifting again would double-count
  // the margin, so never touch their prices — today the `!commission` guard
  // below happens to cover this, but only because operators get no
  // agent_additional_info. Don't rely on that staying true.
  const isOperator = !!agentInfo?.is_operator;

  const getGrossPrice = (price: number, commission?: number, decimals = 0) => {
    if (
      isOperator ||
      price_view !== PriceView.Gross ||
      !commission ||
      commission >= 100
    ) {
      return Number(price?.toFixed(decimals));
    }

    // if we have agent with agent with Gross price view and no commission, we will use DEFAULT_COMMISSION
    if (
      price_view === PriceView.Gross &&
      (isNaN(commission) || commission === null)
    ) {
      commission = DEFAULT_COMMISSION;
    }

    const revenueFactor = 1 - commission / 100;
    const grossPrice = Number(price / revenueFactor)?.toFixed(decimals);

    return Number(grossPrice);
  };

  return getGrossPrice;
};

export default useGetGrossPrice;
